import { IShsEquipmentData } from '../models/installedbase.models';
import { Action, ActionReducer, createFeatureSelector, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import * as MyInstalledBaseActions from '../actions/my-installed-base.actions';

export interface IMyInstalledBaseState {
  equipments: {
    selectable: IShsEquipmentData[];
    other: IShsEquipmentData[];
    isLoaded: boolean;
  }
  contracts: {
    needsAttention: IShsEquipmentData[];
    underContractContracts: IShsEquipmentData[];
    isLoaded: boolean;
  }
}

export const initialState: IMyInstalledBaseState = {
  equipments: {
    selectable: [],
    other: [],
    isLoaded: false,
  },
  contracts: {
    needsAttention: [],
    underContractContracts: [],
    isLoaded: false,
  }
};

export const reducer: ActionReducer<IMyInstalledBaseState> = createReducer(
  initialState,

  on(MyInstalledBaseActions.loadMyInstalledBaseEquipments, (state) => {
    return {
      ...state,
      equipments: {
        ...state.equipments,
        isLoaded: false,
      }
    };
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseEquipmentsSuccess, (state, { selectableEquipments, otherEquipments }) => {
    return {
      ...state,
      equipments: {
        selectable: selectableEquipments,
        other: otherEquipments,
        isLoaded: true,
      }
    };
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseEquipmentsFailure, (state) => {
    return {
      ...state,
      equipments: {
        ...state.equipments,
        isLoaded: true,
      }
    };
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseContracts, (state) => {
    return {
      ...state,
      contracts: {
        ...state.contracts,
        isLoaded: false,
      }
    };
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseContractsSuccess, (state, { needsAttentionContracts, underContractContracts }) => {
    return {
      ...state,
      contracts: {
        needsAttention: needsAttentionContracts,
        underContractContracts: underContractContracts,
        isLoaded: true,
      }
    };
  }),

  on(MyInstalledBaseActions.loadMyInstalledBaseContractsFailure, (state) => {
    return {
      ...state,
      contracts: {
        ...state.contracts,
        isLoaded: true,
      }
    };
  }),
);

export function MyInstalledBaseReducer(state: IMyInstalledBaseState | undefined, action: Action): any {
  return reducer(state, action);
}

export const myInstalledBaseState: MemoizedSelector<object, IMyInstalledBaseState> = createFeatureSelector<IMyInstalledBaseState>('myInstalledBase');

export const selectEquipments: MemoizedSelector<object, IMyInstalledBaseState['equipments']> = createSelector(
  myInstalledBaseState,
  state => state.equipments
);

export const selectContracts: MemoizedSelector<object, IMyInstalledBaseState['contracts']> = createSelector(
  myInstalledBaseState,
  state => state.contracts
);

export const selectSelectableEquipments: MemoizedSelector<object, IShsEquipmentData[]> = createSelector(
  myInstalledBaseState,
  state => state.equipments.selectable
);

export const selectOtherEquipments: MemoizedSelector<object, IShsEquipmentData[]> = createSelector(
  myInstalledBaseState,
  state => state.equipments.other
);

export const selectEquipmentsIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  myInstalledBaseState,
  state => state.equipments.isLoaded
);

export const selectNeedsAttentionContracts: MemoizedSelector<object, IShsEquipmentData[]> = createSelector(
  myInstalledBaseState,
  state => state.contracts.needsAttention
);

export const selectUnderContractContracts: MemoizedSelector<object, IShsEquipmentData[]> = createSelector(
  myInstalledBaseState,
  state => state.contracts.underContractContracts
);

export const selectContractsIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  myInstalledBaseState,
  state => state.contracts.isLoaded
);
